<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";
import ProjectBreadcrumb from "./ProjectBreadcrumb.vue";
import DiagnosticBreadcrumb from "./DiagnosticBreadcrumb.vue";
const route = useRoute();

const title = computed(() => route.meta.title as string);
</script>

<template>
  <ProjectBreadcrumb v-if="title === 'project'" />
  <DiagnosticBreadcrumb v-else-if="title === 'diagnostic'" />
  <div v-else>{{ $t(title) }}</div>
</template>

<style lang="scss" scoped></style>
